<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat class="card-header">
        <v-btn icon exact :to="{name: 'interestdefaults'}"><v-icon>clear</v-icon></v-btn>
        <span class="title">Edit Default Interest</span>
        <v-spacer></v-spacer>
        <v-btn @click="saveItem" depressed class="mx-1" color="success">Save</v-btn>
        <v-btn @click="deleteItem" depressed class="mx-1" color="error">Delete</v-btn>
      </v-toolbar>
      <v-container grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
            v-model="item.name"
            label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
            v-model="item.description"
            label="Description"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      item: {},
      loading: false
    }
  },

  created () {
    this.getItem()
  },

  computed: {
    isNew: function () {
      if (this.$route.params.id === 'new') {
        return true
      }
      return false
    }
  },

  methods: {
    exit: function () {
      this.$router.go(-1)
    },

    deleteItem: function () {
      ApiRequests.interestDefaultDelete(this.item._id).then(r => {
        this.exit()
      })
    },

    getItem: function () {
      if (this.isNew) return

      this.loading = true
      ApiRequests.interestDefaultGet(this.$route.params.id).then(r => {
        this.item = r.data
        this.loading = false
      })
    },

    saveItem: function () {
      this.loading = true

      if (this.isNew) {
        ApiRequests.interestDefaultCreate(this.item).then(r => {
          this.item = r.data
          this.loading = false
          this.exit()
        })
      } else {
        ApiRequests.interestDefaultSave(this.item).then(r => {
          this.item = r.data
          this.loading = false
          this.exit()
        })
      }
    }
  }
}
</script>
